import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const announcementSize = tailwindVariants({
  base: 'w-full',
  variants: {
    size: {
      fluid: '',
      large: 'max-w-3xl',
      medium: 'max-w-lg',
      small: 'max-w-xs',
    },
  },
});

export type AnnouncementSize = NonNullable<VariantProps<typeof announcementSize>['size']>;
